export enum TewerkstellingsTypes {
  BinnenOnderwijs = 1,
  BuitenOnderwijs = 2,
  OpenbaarAmbt = 3,
  Onbezoldigd = 4,
}
